export default {"src":"/_next/static/media/edit.0a39ab87.svg","height":24,"width":24};